import React from 'react';
import styled from 'styled-components';
import UmbracoForm from '~Umbraco/Components/UmbracoForm/UmbracoForm';
import Typography from 'design-system/src/Components/Typography/Typography';
import Metrics from 'design-system/src/Theme/Metrics';
import FlexBox from 'design-system/src/WebComponent/FlexBox/FlexBox.web';
import { FieldValues } from 'react-hook-form';
import { FormField } from '@src/Api/Umbraco/interface/UmbracoTypes';
import { TFunction } from 'i18next';

const Container = styled.div`
  width: 100%;
  padding-bottom: 48px;
`;

interface SignupInterestFormContentProps {
  form: any;
  t: TFunction;
  isMobile: boolean;
  title?: string;
  subtitle?: string;
  initialValues: FieldValues;
  onSubmit: (formData: any) => Promise<boolean>;
}

const getFieldMap = (field: FormField, t: TFunction): FormField => {
  if (
    Object.keys(field.preValues || {}).length > 0 &&
    (field.alias === 'interests' || field.alias === 'musicGenre')
  ) {
    return {
      ...field,
      defaultRules: {
        required: true,
        validate: value => {
          if (Array.isArray(value)) {
            return value.length >= 3 ? true : t('Select at least 3') || '';
          }
          return t('Required') + '';
        },
      },
    };
  }
  return field;
};

const SignupInterestFormContent: React.FC<SignupInterestFormContentProps> = ({
  form,
  t,
  isMobile,
  title,
  subtitle,
  initialValues,
  onSubmit,
}) => (
  <Container>
    <UmbracoForm
      form={form}
      submitLabel={t('Continue') + ''}
      autoValidate={false}
      initialValue={initialValues}
      overrideSubmit={onSubmit}
      fieldMap={field => getFieldMap(field, t)}
      renderPageHeader={() => (
        <FlexBox direction="column" gap={17}>
          <Typography
            variant={isMobile ? 'body2' : 'formTitle'}
            style={{
              marginBottom: Metrics.verticalScale(12),
              textAlign: 'center',
            }}>
            {title}
          </Typography>
          <Typography
            variant={isMobile ? 'body3' : 'body2'}
            style={{
              marginBottom: Metrics.verticalScale(12),
              textAlign: 'center',
            }}>
            {subtitle}
          </Typography>
        </FlexBox>
      )}
    />
  </Container>
);

export default SignupInterestFormContent;